import script from "./BranchSideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BranchSideView.vue?vue&type=script&setup=true&lang=ts"

import "./BranchSideView.vue?vue&type=style&index=0&id=5340ede6&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5340ede6"]])

export default __exports__